export default __webpack_public_path__ + "static/thyssen-3418dfb5d4395fe31d051f43b896076f.svg";